import React from "react";
import ExploreContent from "views/explore/exploreContent";
import { ExploreProvider } from "context/exploreContext";
import { IonPage } from "@ionic/react";
import Header from "views/header";

const Explore = () => {
  return (
    <IonPage>
      <Header />
      <ExploreProvider>
        <ExploreContent />
      </ExploreProvider>
    </IonPage>
  );
};

export default Explore;
